import Header from "../Header";
import "./styles.scss";

const CustomMessageModal = ({
  show,
  onClickClose,
  image,
  heading,
  description,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className="custom-message-modal-container">
      <div className="content-container">
        <Header backEnable onClick={onClickClose} />
        <img src={image} alt="message-modal-image" className="modal-image" />
        <h1 className="modal-heading">{heading}</h1>
        <p className="modal-description">{description}</p>
      </div>
    </div>
  );
};

export default CustomMessageModal;
